import { useQuery } from '@tanstack/react-query';

import { getOnboardingVideo } from '../api/onboarding-video.api';
import { alegeSursaVideo, type SursaVideo } from '../utils/video-sursa';

/**
 * Sursa filmuletului de la pasul 3 din inscriere.
 *
 * `staleTime: Infinity` — materialul editiei nu se schimba in timpul unei vizite,
 * iar o reincarcare in mijlocul vizionarii ar remonta playerul si ar pierde
 * segmentele parcurse, adica exact poarta pe care se sprijina pasul.
 *
 * `retry: 1` — o singura reincercare. Ecranul are o stare onesta pentru „nu se
 * poate acum", cu iesire proprie; a insista mai mult inseamna doar ca omul se
 * uita mai mult timp la un dreptunghi gol.
 *
 * 🔴 Hook-ul nu intoarce `data`, ci STAREA. Asa componenta nu mai poate lua
 * singura decizia „daca n-a venit nimic, pun ceva", si nu se mai poate strecura
 * inapoi un fallback pe filmuletul de test — regula sta intr-un modul pur si
 * testat (`utils/video-sursa.ts`), nu in randare.
 */
export function useOnboardingVideo(): SursaVideo {
    const { data, isError, isPending } = useQuery({
        queryKey: ['onboarding-video', 'editie-curenta'],
        queryFn: getOnboardingVideo,
        staleTime: Infinity,
        retry: 1,
    });

    return alegeSursaVideo({ data, isError, isPending });
}
